<template>
  <div class="ly_top">
    <div class="el_top_title">人づきあいのスキル診断</div>
    <div class="ly_image">
      <img src="../../assets/test.png" width="640" height="398" />
    </div>
    <div class="el_top_text">
      あなたの「人づきあいスキル」<br />
      どのくらいあるでしょうか？<br />
      人づきあいにおける、あなたの得意なことや<br />
      苦手なことを心理学的に診断します！
    </div>
    <div>
      <MaterialButton
        class="el_round_button"
        text="さっそく診断してみる"
        link="tutorial"
        font-size="31px"
        padding="35px"
      ></MaterialButton>
    </div>
  </div>
</template>
<script>
import MaterialButton from '../atoms/MaterialButton'

export default {
  name: 'Top',
  components: {
    MaterialButton: MaterialButton,
  },
}
</script>

<style scoped>
.ly_top {
  position: relative;
  width: 50%;
  top: 100px;
  left: 20px;
}

.ly_image {
  position: absolute;
  left: 500px;
}

.el_top_title {
  text-align: left;
  font-style: normal;
  font-weight: bold;
  font-size: 48px;
  line-height: 70px;

  color: #6b6b6b;
}

.el_top_text {
  width: 528px;

  margin-top: 41px;
  text-align: left;

  font-style: normal;
  font-weight: normal;
  font-size: 24px;
  line-height: 35px;

  color: #6b6b6b;
}

.el_round_button {
  text-align: left;
  height: 123px;
  margin-top: 59px;
}
</style>
